/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_NoteInputs */

const en_options_editor_note = /** @type {(inputs: Options_Editor_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note: The following settings may only apply when utilizing shortcut keys to perform the action.`)
};

const fr_options_editor_note = /** @type {(inputs: Options_Editor_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remarque : les paramètres suivants peuvent ne s'appliquer que lors de l'utilisation de raccourcis clavier pour effectuer l'action.`)
};

const de_options_editor_note = /** @type {(inputs: Options_Editor_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinweis: Die folgenden Einstellungen gelten möglicherweise nur, wenn Sie Tastenkombinationen verwenden, um die Aktion auszuführen.`)
};

const it_options_editor_note = /** @type {(inputs: Options_Editor_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota: le seguenti impostazioni potrebbero essere valide solo quando si utilizzano i tasti di scelta rapida per eseguire l'azione.`)
};

const ru_options_editor_note = /** @type {(inputs: Options_Editor_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примечание: Следующие настройки могут применяться только при использовании сочетаний клавиш для выполнения действия.`)
};

const es_options_editor_note = /** @type {(inputs: Options_Editor_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota: Las siguientes configuraciones solo se pueden aplicar cuando se utilizan teclas de acceso directo para realizar la acción.`)
};

const zh_cn2_options_editor_note = /** @type {(inputs: Options_Editor_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注意：以下设置可能仅在使用快捷键执行操作时适用。`)
};

const ja_options_editor_note = /** @type {(inputs: Options_Editor_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注意: 次の設定は、ショートカット キーを使用してアクションを実行する場合にのみ適用される場合があります。`)
};

const hi_options_editor_note = /** @type {(inputs: Options_Editor_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नोट: निम्नलिखित सेटिंग्स केवल तभी लागू हो सकती हैं जब क्रिया को करने के लिए शॉर्टकट कुंजियों का उपयोग किया जा रहा हो।`)
};

const pt_pt2_options_editor_note = /** @type {(inputs: Options_Editor_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota: As configurações a seguir podem ser aplicadas somente ao utilizar teclas de atalho para executar a ação.`)
};

/**
* | output |
* | --- |
* | "Note: The following settings may only apply when utilizing shortcut keys to perform the action." |
*
* @param {Options_Editor_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_note = /** @type {((inputs?: Options_Editor_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_note(inputs)
	if (locale === "de") return de_options_editor_note(inputs)
	if (locale === "it") return it_options_editor_note(inputs)
	if (locale === "ru") return ru_options_editor_note(inputs)
	if (locale === "es") return es_options_editor_note(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_note(inputs)
	if (locale === "ja") return ja_options_editor_note(inputs)
	if (locale === "hi") return hi_options_editor_note(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_note(inputs)
	return en_options_editor_note(inputs)
});